import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Form, Button } from "react-bootstrap";
import axios from "axios";
import { format } from "date-fns";
import DatePicker from "react-multi-date-picker";
import LoadingComponent from "../../../layouts/nav/loading";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { toast } from "react-toastify"; 
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const baseURL = process.env.REACT_APP_API_BASE_URL;

const Kitchen_Consumption = () => {
  const navigate = useNavigate();

  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
  const user_id = parseInt(localStorage.getItem("user_id"), 10);

//   const [selectedDate, setSelectedDate] = useState(format(new Date(), "yyyy-MM-dd"));

const location = useLocation();
const passedDate = location.state?.selectedDate;

const [selectedDate, setSelectedDate] = useState(
  passedDate || format(new Date(), "yyyy-MM-dd")
);




  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});
  const [expandedItems, setExpandedItems] = useState({});

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${baseURL}/stock-requests`, {
        params: { menu_date: selectedDate, branch_id, user_id },
      });
      setData(res.data.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedDate]);

  const handleDateChange = (date) => setSelectedDate(date.format("YYYY-MM-DD"));

  const getRMKey = (item, rm) => `${item.stockrequest_id}_${rm.raw_material_id}`;

  const handleSelectAll = (schedule_id, checked) => {
    const newSelected = { ...selectedItems };
    data.find(s => s.schedule_id === schedule_id)?.items.forEach(item => {
      if (item.request_status !== 1) newSelected[item.stockrequest_id] = checked;
      item.raw_material_list.forEach(rm => {
        if (rm.rawmaterial_status !== 1) newSelected[getRMKey(item, rm)] = checked;
      });
    });
    setSelectedItems(newSelected);
  };

  const handleSelectItem = (item, checked) => {
    if (item.request_status === 1) return; // read-only
    const newSelected = { ...selectedItems };
    newSelected[item.stockrequest_id] = checked;
    item.raw_material_list.forEach(rm => {
      if (rm.rawmaterial_status !== 1) newSelected[getRMKey(item, rm)] = checked;
    });
    setSelectedItems(newSelected);
  };

  const handleSelectRawMaterial = (item, rm, checked) => {
    if (rm.rawmaterial_status === 1) return; // read-only
    setSelectedItems(prevSelected => {
      const newSelected = { ...prevSelected };
      newSelected[getRMKey(item, rm)] = checked;

      // check item if all raw materials selected
      const allRMsSelected = item.raw_material_list.every(r =>
        r.rawmaterial_status === 1 || newSelected[getRMKey(item, r)]
      );
      if (item.request_status !== 1) newSelected[item.stockrequest_id] = allRMsSelected;

      return newSelected;
    });
  };

  const toggleExpandItem = (stockrequest_id) => {
    setExpandedItems({ ...expandedItems, [stockrequest_id]: !expandedItems[stockrequest_id] });
  };

  const handleAddToCart = async () => {
    const payload = { menu_date: selectedDate, items: [] };

    data.forEach(schedule => {
      schedule.items.forEach(item => {
        const selectedRMs = item.raw_material_list
          .filter(rm => selectedItems[getRMKey(item, rm)])
          .map(rm => rm.raw_material_id);

        if (selectedRMs.length > 0) {
          payload.items.push({
            item_id: item.item_id,
            raw_material_ids: selectedRMs
          });
        }
      });
    });

    if (payload.items.length === 0) {
      // alert("Please select at least one raw material to consume.");
      toast.warning("Please select at least one raw material to consume.");
      return;
    }

    try {
      await axios.post(`${baseURL}/consume-raw-materials`, {
        ...payload,
        schedule_id: data[0]?.schedule_id || 0
      });
      // alert("Selected raw materials consumed successfully!");
      toast.success("Selected raw materials consumed successfully!");
      setSelectedItems({});
      fetchData(); 
      navigate("/manage-weeklyConsumption");
    } catch (err) {
      console.error(err);
      // alert("Failed to consume raw materials. See console for details.");
      toast.error("Failed to consume raw materials.");
    }
  };


return (
  <>
    {/* Header Section */}
    <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
      <div>
        {loading ? (
          <>
            <h4 className="text-primary fw-bold mb-1">
              <Skeleton width={200} height={28} />
            </h4>
            <ol className="breadcrumb fs-7 mb-0">
              <li className="breadcrumb-item"><Skeleton width={100} /></li>
              <li className="breadcrumb-item"><Skeleton width={60} /></li>
              <li className="breadcrumb-item active"><Skeleton width={120} /></li>
            </ol>
          </>
        ) : (
          <>
            <h4 className="text-primary fw-bold mb-1">Kitchen Material Request</h4>
            <ol className="breadcrumb fs-7 mb-0">
              <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
              <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
              <li className="breadcrumb-item active">Stock Management</li>
            </ol>
          </>
        )}
      </div>
    </div>

    {/* Loader Skeleton Section */}
    {loading ? (
      <>
        <Skeleton height={120} className="mb-4 rounded" count={2} />
      </>
    ) : (
      <>
        {data.map(schedule => (
          <div key={schedule.schedule_id} className="mb-4 border p-3 rounded">

            {/* Schedule Header */}
            <div className="mb-3">
              <Row className="g-2 align-items-center">

                <Col xs="4" className="text-start">
                  <div className="mb-1">
                    <small className="text-black fw-semibold" style={{ fontSize: '1.2rem' }}>Date</small>
                  </div>
                  <div
                    className="text-black rounded p-2"
                    style={{ fontSize: '1.0rem', border: '1px solid transparent', minWidth: '80px' }}
                  >
                    {schedule.date
                      ? new Date(schedule.date).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })
                      : '-'}
                  </div>
                </Col>

                <Col xs="4" className="text-center">
                  <div className="mb-1">
                    <small className="text-black fw-semibold" style={{ fontSize: '1.2rem' }}>Food Count</small>
                  </div>
                  <div className="border p-2 rounded d-inline-block text-primary fw-bold" style={{ fontSize: '1.2rem' }}>
                    {schedule.item_count}
                  </div>
                </Col>

                <Col xs="4" className="text-center">
                  <div className="mb-1">
                    <small className="text-black fw-semibold" style={{ fontSize: '1.2rem' }}>Raw Materials Count</small>
                  </div>
                  <div className="border p-2 rounded d-inline-block text-info fw-bold" style={{ fontSize: '1.2rem' }}>
                    {schedule.pending_raw_count}/{schedule.total_raw_material_count}
                  </div>
                </Col>

              </Row>

              {/* Select All */}
              <div className="mt-2 text-start">
                <Form.Check
                  type="checkbox"
                  label="Select All"
                  checked={schedule.items.every(item =>
                    item.raw_material_list.every(rm =>
                      rm.rawmaterial_status === 1 || selectedItems[getRMKey(item, rm)]
                    )
                  )}
                  onChange={(e) => handleSelectAll(schedule.schedule_id, e.target.checked)}
                />
              </div>
            </div>

            {/* Item Cards */}
            <Row>
              {schedule.items.map(item => {
                const isExpanded = !!expandedItems[item.stockrequest_id];
                return (
                  <Col key={item.stockrequest_id} xs={12} sm={6} md={4} className="mb-3">
                    <div className="p-2 border rounded h-100 d-flex flex-column justify-content-between">
                      <div
                        className="d-flex justify-content-between align-items-center mb-2"
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleExpandItem(item.stockrequest_id)}
                      >
                        <Form.Check
                          type="checkbox"
                          label={`${item.item_name} (${item.master_name || "No Master"})`}
                          checked={item.request_status === 1 || !!selectedItems[item.stockrequest_id]}
                          disabled={item.request_status === 1}
                          onChange={(e) => handleSelectItem(item, e.target.checked)}
                          style={{ color: '#000', fontSize: '1.05rem', fontWeight: 500 }}
                        />
                        <span style={{ fontSize: "1.2rem" }}>
                          {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                        </span>
                      </div>

                      {/* Raw Material List */}
                      {isExpanded && item.raw_material_list.length > 0 && (
                        <div style={{ maxHeight: '200px', overflowY: 'auto', marginTop: '10px' }}>
                          <table className="item_data_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                              <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className='min-w-5px'></th>
                                <th className='min-w-150px'>Name</th>
                                <th className='min-w-100px'>Quantity</th>
                              </tr>
                            </thead>
                            <tbody>
                              {item.raw_material_list.map(rm => (
                                <tr key={rm.raw_material_id}>
                                  <td className='text-black'>
                                    <Form.Check
                                      type="checkbox"
                                      checked={rm.rawmaterial_status === 1 || !!selectedItems[getRMKey(item, rm)]}
                                      disabled={rm.rawmaterial_status === 1}
                                      onChange={(e) => handleSelectRawMaterial(item, rm, e.target.checked)}
                                    />
                                  </td>
                                  <td className='text-black'>{rm.raw_material_name}</td>
                                  <td className='text-black'>{rm.quantity} {rm.label_unit}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </Col>
                );
              })}
            </Row>

          </div>
        ))}
      </>
    )}

    {/* Consume Button */}
    {!loading && data[0]?.approval_status === 0 && (
      <div className="text-end mt-3">
        <Button
          variant="primary"
          onClick={handleAddToCart}
          style={{ fontSize: '1.1rem' }}
        >
          Consume
        </Button>
      </div>
    )}
  </>
);


};

export default Kitchen_Consumption;
